// import React from "react";
// import { Dropdown } from "react-bootstrap";
// import { Link } from "react-router-dom";
// import ServitorNotificationDropdown from "../ServitorNotification/ServitorNotificationDropdown";

// const ServitorSiteNavbar = ({ servitor, handleLogout }) => {
//   return (
//     <nav className="servitorsite-navbar">
//       <h2 className="servitorsite-navbar-title">HelpNao</h2>
//       <div className="servitorsite-navbar-right" style={{ display: "flex", alignItems: "center" }}>
//         {/* Notification Dropdown */}
//         <ServitorNotificationDropdown servitorId={servitor.Id} />

//       <div className="servitorsite-navbar-profile">
//         <Dropdown align="end">
//           <Dropdown.Toggle
//             variant="link"
//             id="dropdown-basic"
//             className="servitorsite-profile-icon"
//           >
//             <img
//               src={
//                 servitor?.image
//                   ? `http://localhost:4001/uploads/${servitor.image}`
//                   : "https://via.placeholder.com/40"
//               }
//               alt="Servitor"
//             />
//           </Dropdown.Toggle>
//           <Dropdown.Menu className="servitorsite-dropdown-menu">
//             <div className="dropdown-header">
//               <img
//                 src={
//                   servitor?.image
//                     ? `http://localhost:4001/uploads/${servitor.image}`
//                     : "https://via.placeholder.com/40"
//                 }
//                 alt="Servitor"
//                 className="dropdown-profile-pic"
//               />
//               <div className="dropdown-profile-info">
//                 <p className="dropdown-profile-name">
//                   {servitor?.FirstName} {servitor?.LastName}
//                 </p>
//                 <p className="dropdown-profile-role">{servitor?.role}</p>
//               </div>
//             </div>
//             <Dropdown.Divider />
//             <Dropdown.Item as={Link} to="/servitor/servitor-profile" className="dropdown-item">
//               <i className="bi bi-person-circle"></i> Profile
//             </Dropdown.Item>
//             <Dropdown.Item href="#/change-password" className="dropdown-item">
//               <i className="bi bi-key"></i> Change Password
//             </Dropdown.Item>
//             {/* <Dropdown.Item as={Link} to="/servitor/notifications" className="dropdown-item">
//               <i className="bi bi-bell"></i> Notifications
//             </Dropdown.Item> */}
//             <Dropdown.Item href="#/settings" className="dropdown-item">
//               <i className="bi bi-gear"></i> Settings
//             </Dropdown.Item>
//             <Dropdown.Item href="#/help" className="dropdown-item">
//               <i className="bi bi-question-circle"></i> Help & Support
//             </Dropdown.Item>
//             <Dropdown.Divider />
//             <Dropdown.Item onClick={handleLogout} className="dropdown-item">
//               <i className="bi bi-box-arrow-right"></i> Logout
//             </Dropdown.Item>
//           </Dropdown.Menu>
//         </Dropdown>
//       </div>
//       </div>
//     </nav>
//   );
// };

// export default ServitorSiteNavbar;






// ***** All is okay and working (25-6-25) ***** //

// import React from "react";
// import { Dropdown } from "react-bootstrap";
// import { Link } from "react-router-dom";
// import ServitorNotificationDropdown from "../ServitorNotification/ServitorNotificationDropdown";

// const ServitorSiteNavbar = ({ servitor, handleLogout, toggleSidebar, isMobile }) => {
//   return (
//     <nav className="servitorsite-navbar">
//       {/* <h2 className="servitorsite-navbar-title">HelpNao</h2> */}
//       <div className="servitorsite-navbar-left">
//         {isMobile && (
//           <button className="hamburger-menu" onClick={toggleSidebar}>
//             <i className="bx bx-menu"></i>
//           </button>
//         )}
//         <h2 className="servitorsite-navbar-title">HelpNao</h2>
//       </div>

//       <div className="servitorsite-navbar-right" style={{ display: "flex", alignItems: "center" }}>
//         {/* Notification Dropdown */}
//         <ServitorNotificationDropdown servitorId={servitor.Id} />

//       <div className="servitorsite-navbar-profile">
//         <Dropdown align="end">
//           <Dropdown.Toggle
//             variant="link"
//             id="dropdown-basic"
//             className="servitorsite-profile-icon"
//           >
//             <img
//               src={
//                 servitor?.image
//                   ? `http://localhost:4001/uploads/${servitor.image}`
//                   : "https://via.placeholder.com/40"
//               }
//               alt="Servitor"
//             />
//           </Dropdown.Toggle>
          
//           <Dropdown.Menu className="servitorsite-dropdown-menu">
//             <div className="dropdown-header">
//               <img
//                 src={
//                   servitor?.image
//                     ? `http://localhost:4001/uploads/${servitor.image}`
//                     : "https://via.placeholder.com/40"
//                 }
//                 alt="Servitor"
//                 className="dropdown-profile-pic"
//               />
//               <div className="dropdown-profile-info">
//                 <p className="dropdown-profile-name">
//                   {servitor?.FirstName} {servitor?.LastName}
//                 </p>
//                 <p className="dropdown-profile-role">{servitor?.role}</p>
//               </div>
//             </div>
//             <Dropdown.Divider />
//             <Dropdown.Item as={Link} to="/servitor/servitor-profile" className="dropdown-item">
//               <i className="bi bi-person-circle"></i> Profile
//             </Dropdown.Item>
//             {/* <Dropdown.Item href="#/change-password" className="dropdown-item">
//               <i className="bi bi-key"></i> Change Password
//             </Dropdown.Item> */}
//             {/* <Dropdown.Item as={Link} to="/servitor/notifications" className="dropdown-item">
//               <i className="bi bi-bell"></i> Notifications
//             </Dropdown.Item> */}
//             <Dropdown.Item href="#/settings" className="dropdown-item">
//               <i className="bi bi-gear"></i> Settings
//             </Dropdown.Item>
//             <Dropdown.Item href="#/help" className="dropdown-item">
//               <i className="bi bi-question-circle"></i> Help & Support
//             </Dropdown.Item>
//             <Dropdown.Divider />
//             <Dropdown.Item onClick={handleLogout} className="dropdown-item">
//               <i className="bi bi-box-arrow-right"></i> Logout
//             </Dropdown.Item>
//           </Dropdown.Menu>
//         </Dropdown>
//       </div>
//       </div>
//     </nav>
//   );
// };

// export default ServitorSiteNavbar;


// ***** Upper code All is okay and working (25-6-25) ***** //










// ***** Add Translator EN BN (25-6-25) ***** //

import React, { useState, useEffect, useRef } from "react";
import { Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import ServitorNotificationDropdown from "../ServitorNotification/ServitorNotificationDropdown";
import { useTranslation } from "react-i18next";
import { URL } from "../../../config";
// import axios from "axios";


const ServitorSiteNavbar = ({ servitor, handleLogout, toggleSidebar, isMobile }) => {
  const { t, i18n } = useTranslation("servitor"); // NEW: Use 'servitor' namespace
    const [languageDropdownOpen, setLanguageDropdownOpen] = useState(false);
    const languageDropdownRef = useRef(null);
  
    // NEW: Handle language dropdown toggle
    const toggleLanguageDropdown = () => {
      setLanguageDropdownOpen(!languageDropdownOpen);
    };
  
    // NEW: Handle language change and sync with backend
    const handleLanguageChange = async (lang) => {
      i18n.changeLanguage(lang);
      setLanguageDropdownOpen(false);
      // if (servitor) {
      //   try {
      //     await axios.put(
      //       `http://localhost:4001/servitors/${servitor.Id}/language`,
      //       { language: lang },
      //       {
      //         headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      //       }
      //     );
      //   } catch (error) {
      //     console.error("Error updating language:", error);
      //   }
      // }
    };
  
    // NEW: Close language dropdown when clicking outside
    useEffect(() => {
      const handleClickOutside = (event) => {
        if (
          languageDropdownRef.current &&
          !languageDropdownRef.current.contains(event.target)
        ) {
          setLanguageDropdownOpen(false);
        }
      };
      if (languageDropdownOpen) {
        document.addEventListener("mousedown", handleClickOutside);
        document.addEventListener("touchstart", handleClickOutside);
      }
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
        document.removeEventListener("touchstart", handleClickOutside);
      };
    }, [languageDropdownOpen]);

  return (
    <nav className="servitorsite-navbar">
      {/* <h2 className="servitorsite-navbar-title">HelpNao</h2> */}
      <div className="servitorsite-navbar-left">
        {isMobile && (
          <button className="hamburger-menu" onClick={toggleSidebar}>
            <i className="bx bx-menu"></i>
          </button>
        )}
        {/* <h2 className="servitorsite-navbar-title">HelpNao</h2> */}

        {/* Clickable brand -> /servitor */}
          <Link
            to="/servitor"
            className="servitorsite-navbar-title-link"
            aria-label="Go to Servitor dashboard"
          >
            <h2 className="servitorsite-navbar-title">HelpNao</h2>
          </Link>

      </div>

      <div className="servitorsite-navbar-right" style={{ display: "flex", alignItems: "center" }}>

        {/* NEW: Language Dropdown */}
        <div className="servitorsite-language" ref={languageDropdownRef}>
          <div
            className="servitorsite-language-toggle"
            onClick={toggleLanguageDropdown}
            aria-label={`Select language, current: ${t(`navbar.${i18n.language}`)}`} // NEW: Accessibility
          >
            <i className="bx bx-globe servitorsite-language-icon"></i>
            <span>{i18n.language.toUpperCase()}</span>
            <i
              className={`bx bx-caret-down servitorsite-dropdown-icon ${
                languageDropdownOpen ? "open" : ""
              }`}
            ></i>
          </div>
          {languageDropdownOpen && (
            <div className="servitorsite-language-dropdown">
              <div
                className="servitorsite-language-option"
                onClick={() => handleLanguageChange("en")}
              >
                {t("navbar.english")}
              </div>
              <div
                className="servitorsite-language-option"
                onClick={() => handleLanguageChange("bn")}
              >
                {t("navbar.bangla")}
              </div>
            </div>
          )}
        </div>

        {/* Notification Dropdown */}
        <ServitorNotificationDropdown servitorId={servitor.Id} />

      <div className="servitorsite-navbar-profile">
        <Dropdown align="end">
          <Dropdown.Toggle
            variant="link"
            id="dropdown-basic"
            className="servitorsite-profile-icon"
          >
            <img
              src={
                servitor?.image
                  ? `${URL}/uploads/${servitor.image}`
                  : "https://via.placeholder.com/40"
              }
              alt="Servitor"
            />
          </Dropdown.Toggle>
          
          <Dropdown.Menu className="servitorsite-dropdown-menu">
            <div className="dropdown-header">
              <img
                src={
                  servitor?.image
                    ? `${URL}/uploads/${servitor.image}`
                    : "https://via.placeholder.com/40"
                }
                alt="Servitor"
                className="dropdown-profile-pic"
              />

              {/* <div className="dropdown-profile-info">
                <p className="dropdown-profile-name">
                  {servitor?.FirstName} {servitor?.LastName}
                </p>
                <p className="dropdown-profile-role">{servitor?.role}</p>
              </div> */}

              <div className="dropdown-profile-info">
                <p
                  className="dropdown-profile-name"
                  title={`${servitor?.FirstName || ""} ${servitor?.LastName || ""}`}
                >
                  {servitor?.FirstName} {servitor?.LastName}
                </p>
                <p className="dropdown-profile-role">{servitor?.role}</p>
              </div>



            </div>
            <Dropdown.Divider />
            <Dropdown.Item as={Link} to="/servitor/servitor-profile" className="dropdown-item">
              {/* <i className="bi bi-person-circle"></i> Profile */}
              <i className="bi bi-person-circle"></i> {t("navbar.profile")}

            </Dropdown.Item>

            <Dropdown.Item as={Link} to="/servitor/servitor-refrewards" className="dropdown-item">
              <i className="bx bx-gift"></i> {t("navbar.referral")}
            </Dropdown.Item>


            {/* Need to updated routes or pages for future */}

            {/* <Dropdown.Item href="#/settings" className="dropdown-item">
              <i className="bi bi-gear"></i> {t("navbar.settings")}
            </Dropdown.Item>

            <Dropdown.Item href="#/help" className="dropdown-item">
              <i className="bi bi-question-circle"></i> {t("navbar.help")}
            </Dropdown.Item> */}

            <Dropdown.Divider />
            <Dropdown.Item onClick={handleLogout} className="dropdown-item">
              {/* <i className="bi bi-box-arrow-right"></i> Logout */}
              <i className="bi bi-box-arrow-right"></i> {t("navbar.logout")}
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
      </div>
    </nav>
  );
};

export default ServitorSiteNavbar;